// extracted by mini-css-extract-plugin
module.exports = {"ChartSize":"ScoreGraph_ChartSize__212Qz"};